__turbopack_context__.v({
  "contactsbanner": "styles-module__tSvZ-q__contactsbanner",
  "content": "styles-module__tSvZ-q__content",
  "description": "styles-module__tSvZ-q__description",
  "formWrapper": "styles-module__tSvZ-q__formWrapper",
  "title": "styles-module__tSvZ-q__title",
  "wrapper": "styles-module__tSvZ-q__wrapper",
});
